import { useParams } from 'react-router'
import type { IChatbotFullData } from 'entities/Chatbot/api/chatbotTypes'
import { UnifiedAgentProvider } from 'pages/chatbot/ui/UnifiedAgent'
import { ChatbotEditV2Page } from 'pages/chatbot/pages/chatbotEdit/ui/ChatbotEditV2Page'

type IChatbotEditV2Layout = {
  initialData: IChatbotFullData
}

export const ChatbotEditV2Layout = ({ initialData }: IChatbotEditV2Layout) => {
  const { agentId } = useParams()

  return (
    <UnifiedAgentProvider agentId={agentId ? +agentId : null} initialData={initialData}>
      <ChatbotEditV2Page />
    </UnifiedAgentProvider>
  )
}
